import { render, staticRenderFns } from "./notice-pc.vue?vue&type=template&id=1d77140e&scoped=true&"
import script from "./notice-pc.vue?vue&type=script&lang=js&"
export * from "./notice-pc.vue?vue&type=script&lang=js&"
import style0 from "./notice-pc.vue?vue&type=style&index=0&id=1d77140e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d77140e",
  null
  
)

export default component.exports